import React, { Component, Children } from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/views/docPage.jsx";

class DocListItem extends Component {
  render() {
    const { classes, children } = this.props;
    return (
      <div className={classes.docItem} style={{ height: this.props.height }}>
        <label className={classes.docItemTitle}>{this.props.title}</label>
        {children}
        {this.props.memo ? (
          <label
            className={[classes.docItemMemo, this.props.className]}
            style={this.props.style}
          >
            {this.props.memo}
          </label>
        ) : null}
      </div>
    );
  }
}

export default withStyles(styles)(DocListItem);
